import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Footer from '../Components/Footer';
import Auth from '../Function/Auth';
import Header from '../Components/Header';
import { toast, ToastContainer } from "react-toastify";
import axios from 'axios';
import Web3 from 'web3';
import { decryptCode } from '../Components/Decrypt';

function Withdraw() {
    const authToken = sessionStorage.getItem('authToken');
    const baseurl = process.env.REACT_APP_BASE_API_URL;
    const [analytics, setAnalytics] = useState([]);
    const [isApprove, setApprove] = useState(false);
    const [tabelLoading, setTableLoading] = useState(false);
    const [ClinetData, setClientData] = useState([]);
    const [pagination, setPagination] = useState([]);
    const [clientEmail, setCleintEmail] = useState("");
    const [clientName, setClintName] = useState("");
    const [network_type, setNetworkType] = useState("");
    const [userStatus, setStatus] = useState("");
    const [stakeStatus, setStakeStatus] = useState("");
    const [viewData, setViewData] = useState("");
    const [mainBalance, setMainbalance] = useState(0);
    const [bnbBalance, setBnbBalance] = useState(0);
    const [walletAddress, setWalletAddress] = useState(0);
    const [walletKey, setWalletKey] = useState(0);
    const [totalWithdraw, setTotalWithdraw] = useState(0);
    const [totalApprovedWithdraw, setApprovedWithdraw] = useState(0);
    const [pendingWithdraw, setPendingWithdraw] = useState(0);
    const [totalRejectWithdraw, setRejectWithdraw] = useState(0);


    const [editPaidAmount, setEditPaidAmount] = useState("");
    const [editFromAddress, setEditFromAddress] = useState("");
    const [editToAddress, setEditToAddress] = useState("");
    const [editTxnHash, setEditTxnHash] = useState("");
    const [editStatus, setEditStatus] = useState("");
    const [deposit_id, setDepositId] = useState([]);
    const [error, setError] = useState("");
    const [userCode, setUserCode] = useState("");

    const [remark, setRemark] = useState("");
    const [isRejectPanel, setRejectPanel] = useState(false);
    const BSC_RPC = 'https://bsc-dataseed.binance.org/';
    const web3 = new Web3(BSC_RPC);
    const USDT_ADDRESS = '0x55d398326f99059fF775485246999027B3197955';

    const USDT_ABI = [{ "inputs": [], "payable": false, "stateMutability": "nonpayable", "type": "constructor" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "owner", "type": "address" }, { "indexed": true, "internalType": "address", "name": "spender", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "value", "type": "uint256" }], "name": "Approval", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "previousOwner", "type": "address" }, { "indexed": true, "internalType": "address", "name": "newOwner", "type": "address" }], "name": "OwnershipTransferred", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "from", "type": "address" }, { "indexed": true, "internalType": "address", "name": "to", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "value", "type": "uint256" }], "name": "Transfer", "type": "event" }, { "constant": true, "inputs": [], "name": "_decimals", "outputs": [{ "internalType": "uint8", "name": "", "type": "uint8" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "_name", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "_symbol", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [{ "internalType": "address", "name": "owner", "type": "address" }, { "internalType": "address", "name": "spender", "type": "address" }], "name": "allowance", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "spender", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "approve", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [{ "internalType": "address", "name": "account", "type": "address" }], "name": "balanceOf", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "burn", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "decimals", "outputs": [{ "internalType": "uint8", "name": "", "type": "uint8" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "spender", "type": "address" }, { "internalType": "uint256", "name": "subtractedValue", "type": "uint256" }], "name": "decreaseAllowance", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "getOwner", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "spender", "type": "address" }, { "internalType": "uint256", "name": "addedValue", "type": "uint256" }], "name": "increaseAllowance", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "mint", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "name", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "owner", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [], "name": "renounceOwnership", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "symbol", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "totalSupply", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "recipient", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "transfer", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "sender", "type": "address" }, { "internalType": "address", "name": "recipient", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "transferFrom", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "newOwner", "type": "address" }], "name": "transferOwnership", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }];






    useEffect(() => {

        fetchdataClient(1);
    }, []);


    const fetchdataClient = async (page) => {
        console.log('Token ', authToken);

        const searchData = {
            page: page,
            to_address: clientEmail,
            txn_hash: clientName,
            status: userStatus,
            my_code: userCode
        };


        try {
            const client = await fetch(`${baseurl}/client/withdraw-details`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${authToken}`,
                },
                body: JSON.stringify(searchData),
            });

            if (client.status === 429) {
                console.error("Rate limit exceeded. Please try again later.");
                return; // Stop further processing
            }

            const clientData = await client.json();
            console.log('Static data', clientData);

            if (clientData.status) {
                setAnalytics(clientData.analytics);
                setClientData(clientData.data);
                setPagination(clientData.pagination);
                setWalletAddress(clientData.withdrawAddress)
                setWalletKey(clientData.withdrawKey)
                setTableLoading(true);
                setTotalWithdraw(clientData.total_withdraw);
                setApprovedWithdraw(clientData.approved_withdraw);
                setRejectWithdraw(clientData.rejected_withdraw);
                setPendingWithdraw(clientData.pending_withdraw);

            } else {
                // Handle any error condition
                setTableLoading(true);
            }
        } catch (error) {
            console.error('Fetch error:', error);
        }
    };


    const passData = (dataClient) => {
        setDepositId(dataClient);
        setViewData(dataClient);
        setEditPaidAmount(dataClient.paid_amount);
        setEditFromAddress(dataClient.from_address);
        setEditToAddress(dataClient.to_address);
        setEditTxnHash(dataClient.txn_hash);
        setEditStatus(dataClient.txn_hash);
    };



    const updateDeposit = async () => {

        console.log(editPaidAmount, editFromAddress, editToAddress, editTxnHash, editStatus)

        if (!deposit_id) return setError("Try again.");
        if (!editPaidAmount) return setError("Paid amount id required.");
        if (!editFromAddress) return setError("From address is required");
        if (!editToAddress) return setError("To address is reuired.");
        if (!editTxnHash) return setError("Txn Hash is required.");
        if (!editStatus) return setError("Status is required.");
        if (!authToken) return setError("Authentication is required.");


        const formData = {
            deposit_id: deposit_id.id,
            paid_amount: editPaidAmount,
            from_address: editFromAddress,
            to_address: editToAddress,
            txn_hash: editTxnHash,
            status: editStatus
        };

        console.log("Sending Data:", formData);

        try {
            const response = await fetch(`${baseurl}/client/deposit-update`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${authToken}`,
                },
                body: JSON.stringify(formData),
            });

            const data = await response.json(); // Get raw response
            console.log("Raw API Response:", data); // Log response before parsing


            if (data.status) {
                toast.success(data.message)
                window.location.href = "";
            }
            else {
                toast.error(data.message)

            }
        } catch (error) {
            console.error("Fetch error:", error);
            setError("Network error. Please check your connection and try again.");
            toast.error("Network error. Please check your connection and try again.");
        }
    }


    const handlePageChange = async (page) => {

        setTableLoading(false)
        fetchdataClient(page);
    }

    const searchData = () => {

        setTableLoading(false)
        fetchdataClient(1);
    }

    const handleProfileDataFetched = (data) => {

    }




    const rejectWithdraw = async () => {
        const fromData = {
            withdraw_id: viewData.id,
            remark: remark,
        };

        try {
            const response = await axios.post(
                `${baseurl}/client/rejectWithdraw`,
                fromData,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${authToken}`,
                    },
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    }
                }
            );

            if (response.status === 429) {
                console.error("Rate limit exceeded. Please try again later.");
                return;
            }

            const clientData = response.data;
            console.log('Static data', clientData);

            if (clientData.status) {
                toast.success(clientData.message)
                setTableLoading(true);
            } else {
                setTableLoading(true);
                toast.error(clientData.message)// Or handle differently if needed
            }
        } catch (error) {
            console.error('Axios error:', error);
        }
    };


     const loadBalance = async () => {
        console.log('Approve Withdraw')
        setApprove(true)
    
            console.log('Wallet Adrress', walletAddress)
            try {
                const web3 = new Web3(new Web3.providers.HttpProvider(BSC_RPC));
                const contract = new web3.eth.Contract(USDT_ABI, USDT_ADDRESS);
    
                const rawBalance = await contract.methods.balanceOf(walletAddress).call();
    
                // Optional: verify decimals if unsure
                const decimals = await contract.methods.decimals().call(); // should return 18
    
                // Convert from wei (18 decimals) to readable number
                const formattedBalance = web3.utils.fromWei(rawBalance, 'ether');
    
                setMainbalance(formattedBalance)
    
                // 2. Get BNB Balance
                const rawBNBBalance = await web3.eth.getBalance(walletAddress);
                const formattedBNBBalance = web3.utils.fromWei(rawBNBBalance, 'ether');
                setBnbBalance(formattedBNBBalance);
    
            } catch (error) {
                console.error('Error fetching USDT balance:', error);
                return null;
            }
        };


     const approveWithdraw = async () => {
    try {
        const privateKey = await decryptCode(walletKey, walletAddress);

        const addressFrom = walletAddress;
        const addressTo = viewData.to_address;

        console.log('paid amount',viewData.paid_amount);

        const contract = new web3.eth.Contract(USDT_ABI, USDT_ADDRESS);

        // Convert to USDT decimals (6 decimals)
        const amountInWei = web3.utils.toWei(viewData.paid_amount, 'ether');

        const txData = contract.methods.transfer(addressTo, amountInWei).encodeABI();

        const nonce = await web3.eth.getTransactionCount(addressFrom);
        const gasPrice = await web3.eth.getGasPrice();

        const tx = {
            from: addressFrom,
            to: USDT_ADDRESS,
            data: txData,
            gas: 100000,
            gasPrice,
            nonce,
            chainId: 56 // BSC Mainnet (change if on testnet or Ethereum)
        };

        const signedTx = await web3.eth.accounts.signTransaction(tx, privateKey);

        const receipt = await web3.eth.sendSignedTransaction(signedTx.rawTransaction);

        toast.success(`✅ Transfer successful: ${receipt.transactionHash}`);

        updateWithdrawStatus(viewData.id,receipt.transactionHash)
        
    } catch (error) {
        console.error("Transfer failed:", error);
        toast.error("❌ Transfer failed: " + error.message);
    }
};
 



     // Function to update withdraw status in backend
    const updateWithdrawStatus = async (withdrawId, txnHash) => {
        try {
            const formData = {
                withdraw_id: withdrawId,
                txn_hash: txnHash,
            };

            const response = await fetch(`${baseurl}/client/autoWithdrawUpdate`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${authToken}`,
                },
                body: JSON.stringify(formData),
            });

            const data = await response.json();

            window.location.href = ""; // Optional - redirects the page
            
            if (!data.status) {
                console.error("Failed to update withdraw status:", data.message);
            }
            
            return data;
        } catch (error) {
            console.error("Error updating withdraw status:", error);
            return null;
        }
    };



    return (
        <>
            <Header>
                {!authToken && <Auth onProfileDataFetched={handleProfileDataFetched} />}
                <div className="main-content app-content" >
                    <div className="container-fluid">
                        {/* Page Header */}
                        <div className="d-md-flex d-block align-items-center justify-content-between my-4 page-header-breadcrumb">
                            <div>


                            </div>
                        </div>
                        {/* End Page Header */}

                        {/* row */}
                        <div className="row">
                            <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                                <div className="card overflow-hidden sales-card bg-primary-gradient">
                                    <div className="px-3 pt-3  pb-2 pt-0">
                                        <div>
                                            <h6 className="mb-3 fs-12 text-fixed-white">TOTAL WITHDRAW : {analytics ? analytics.total_no_of_withdraws : '0'}</h6>
                                        </div>
                                        <div className="pb-0 mt-0">
                                            <div className="d-flex">
                                                <div>
                                                    <h4 className="fs-20 fw-bold mb-1 text-fixed-white">

                                                        ${totalWithdraw}

                                                    </h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="compositeline" />
                                </div>
                            </div>

                            <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                                <div className="card overflow-hidden sales-card bg-warning-gradient">
                                    <div className="px-3 pt-3  pb-2 pt-0">
                                        <div>
                                            <h6 className="mb-3 fs-12 text-fixed-white">PENDING WITHDRAW : {analytics ? analytics.total_no_of_pending_withdraws : '0'}</h6>
                                        </div>
                                        <div className="pb-0 mt-0">
                                            <div className="d-flex">
                                                <div>
                                                    <h4 className="fs-20 fw-bold mb-1 text-fixed-white">

                                                        ${pendingWithdraw}
                                                    </h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="compositeline4" />
                                </div>
                            </div>
                            <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                                <div className="card overflow-hidden sales-card bg-danger-gradient">
                                    <div className="px-3 pt-3  pb-2 pt-0">
                                        <div>
                                            <h6 className="mb-3 fs-12 text-fixed-white">REJECT WITHDRAW : {analytics ? analytics.total_no_of_reject_withdraws : '0'}</h6>
                                        </div>
                                        <div className="pb-0 mt-0">
                                            <div className="d-flex">
                                                <div>
                                                    <h4 className="fs-20 fw-bold mb-1 text-fixed-white">

                                                         ${totalRejectWithdraw}
                                                    </h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="compositeline2" />
                                </div>
                            </div>
                            <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                                <div className="card overflow-hidden sales-card bg-success-gradient">
                                    <div className="px-3 pt-3  pb-2 pt-0">
                                        <div>
                                            <h6 className="mb-3 fs-12 text-fixed-white">SUCCESS WITHDRAW : {analytics ? analytics.total_no_of_success_withdraws : '0'}</h6>
                                        </div>
                                        <div className="pb-0 mt-0">
                                            <div className="d-flex">
                                                <div>
                                                    <h4 className="fs-20 fw-bold mb-1 text-fixed-white">

                                                        ${totalApprovedWithdraw}
                                                    </h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="compositeline3" />
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-12 col-lg-12 col-xl-12">
                                <div className="card card-table ">
                                    <div className="row">
                                          <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                                            <div className="mt-3 ">
                                                <lavel>User Code</lavel>
                                                <input type="text" value={userCode} onChange={(e) => setUserCode(e.target.value)} className="form-control" placeholder="Enter user Code" />
                                            </div>
                                        </div>

                                        <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                                            <div className="mt-3 ">
                                                <lavel>Wallet Address</lavel>
                                                <input type="text" value={clientEmail} onChange={(e) => setCleintEmail(e.target.value)} className="form-control" placeholder="Enter Wallet Address" />
                                            </div>
                                        </div>



                                        <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                                            <div className="mt-3 ">
                                                <lavel>Txn Hash</lavel>
                                                <input type="text" value={clientName} onChange={(e) => setClintName(e.target.value)} className="form-control" placeholder="Enter Txn HAsh" />
                                            </div>
                                        </div>

                                        <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                                            <div className="mt-3">
                                                <label>Status</label>
                                                <select className="form-control" value={userStatus} onChange={(e) => setStatus(e.target.value)}>
                                                    <option value="">All</option>
                                                    <option value="success">Success</option>
                                                    <option value="pending">Pending</option>
                                                    <option value="reject">Reject</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-xl-12 col-lg-12 col-md-12 col-xm-12">
                                            <div className="mt-3 text-end">

                                                <button onClick={searchData} className="btn btn-primary btn-block mt-3">Search Data</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* row closed */}

                        {/* row opened */}
                        <div className="row">
                            <div className="col-md-12 col-lg-12 col-xl-12">
                                <div className="card card-table">
                                    <div className=" card-header p-0 d-flex justify-content-between mt-3">
                                        <h3 className="card-title mb-1 text-primary">Withdraw Data</h3>
                                    </div>
                                    <div class="gridjs-footer">
                      <div class="gridjs-pagination">
                        <div role="status" aria-live="polite" class="gridjs-summary" title="Page 1 of 1">Showing <b>{pagination.current_page}</b> to <b>{pagination.per_page}</b> of <b>{pagination.total}</b> results</div>
                        <div className="gridjs-pages text-end">
                            {/* Previous Button */}
                            <button  tabIndex="0"  role="button"  title="Previous"  aria-label="Previous"  className={pagination.current_page === 1 ? "disabled" : ""}  onClick={() => handlePageChange(pagination.current_page - 1)}  disabled={pagination.current_page === 1}> Previous</button>

                            {/* First Page */}
                            <button  tabIndex="0"  role="button"  className={` ${pagination.current_page === 1 ? "gridjs-currentPage" : ""}`}  title="Page 1"  aria-label="Page 1"  onClick={() => handlePageChange(1)}> 1</button>

                            {/* Ellipsis if needed */}
                            {pagination.current_page > 3 && <span>...</span>}

                            {/* Middle Pages (2 dynamic pages around current) */}
                            {Array.from({ length: 5 }, (_, i) => { const page = pagination.current_page - 2 + i;
                              if (page > 1 && page < pagination.last_page) {
                                return (
                                  <button key={page} tabIndex="0" role="button" className={` ${pagination.current_page === page ? "gridjs-currentPage" : ""}`} title={`Page ${page}`} 
                                    aria-label={`Page ${page}`} onClick={() => handlePageChange(page)}>
                                    {page}
                                  </button>
                                );
                              }
                              return null;
                            })}

                            {/* Ellipsis if needed */}
                            {pagination.current_page < pagination.last_page - 2 && <span>...</span>}

                            {/* Last Page */}
                            {pagination.last_page > 1 && (
                              <button  tabIndex="0" role="button" className={` ${pagination.current_page === pagination.last_page ? "gridjs-currentPage" : ""}`} title={`Page ${pagination.last_page}`} aria-label={`Page ${pagination.last_page}`} 
                                onClick={() => handlePageChange(pagination.last_page)}>
                                {pagination.last_page}
                              </button>
                            )}

                            {/* Next Button */}
                            <button tabIndex="0" role="button" title="Next" aria-label="Next" className={pagination.current_page === pagination.last_page ? "disabled" : ""} onClick={() => handlePageChange(pagination.current_page + 1)} disabled={pagination.current_page === pagination.last_page}>
                              Next
                            </button>
                          </div>
                      </div>
                    </div>
                                    <div className="table-responsive country-table">
                                        {tabelLoading ? (
                                            <table className="table table-striped table-bordered mb-0 text-nowrap mt-3" >

                                                <thead>
                                                    <tr>
                                                        <th className="wd-lg-25p">Name</th>
                                                        <th className="wd-lg-25p">Available Amount</th>
                                                        <th className="wd-lg-25p">Withdraw Amount</th>
                                                        <th className="wd-lg-25p">Remain Amount</th>
                                                        <th className="wd-lg-25p">Wallet Address</th>
                                                        <th className="wd-lg-25p">Txn HAsh</th>
                                                        <th className="wd-lg-25p">Date Time</th>
                                                        <th className="wd-lg-25p">Status</th>
                                                        <th className="wd-lg-25p">ACTION</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {ClinetData.length > 0 ? (
                                                        ClinetData.map((dataClient, index) => (
                                                            <tr key={index}>
                                                                <td> <a className="text-primary" href={`/clientsDetails?userId=` + dataClient.user_id}>{dataClient.user_name || 'N/A'}</a> 
                                                                <br/>
                                                                {dataClient?.my_code}</td>
                                                                <td> {dataClient.available_amount || '0'} </td>
                                                                <td> {dataClient.withdraw_amount || 'N/A'} </td>
                                                                <td> {dataClient.remain_amount || 'N/A'} </td>
                                                                <td><a className="text-primary" href={`https://bscscan.com/address/` + dataClient.to_address} target='blank'> {dataClient.to_address ? `${dataClient.to_address.slice(0, 5)}...${dataClient.to_address.slice(-5)}` : 'N/A'} </a></td>
                                                                <td> <a className="text-primary" href={`https://bscscan.com/tx/` + dataClient.to_address} target='blank'>{dataClient.txn_hash ? `${dataClient.txn_hash.slice(0, 5)}...${dataClient.txn_hash.slice(-5)}` : 'N/A'}</a> </td>
                                                                <td> {dataClient.date_time || 'N/A'} </td>
                                                                <td>
                                                                    {dataClient && dataClient.status
                                                                        ? dataClient.status === 'success' ? (
                                                                            <span className="badge bg-success">Active</span>
                                                                        ) : (
                                                                            <span className="badge bg-danger">{dataClient.status} </span>
                                                                        ) : 'N/A'}
                                                                </td>
                                                                <td>


                                                                    <a data-bs-effect="effect-scale" onClick={(e) => passData(dataClient)} data-bs-toggle="modal" href="#exampleModal" className="btn btn-sm btn-primary mr-5" >
                                                                        <i className="fa fa-eye"></i>
                                                                    </a>

                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td>No Data Found</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        ) : (
                                            <div className="text-center">
                                                <div class="d-flex justify-content-center mb-4">
                                                    <div class="spinner-border" role="status">
                                                        <span class="visually-hidden">Loading...</span>
                                                    </div>
                                                </div>
                                            </div>
                                        )}


                                    </div>
                                    <div class="gridjs-footer">
                                        <div class="gridjs-pagination">
                                            <div role="status" aria-live="polite" class="gridjs-summary" title="Page 1 of 1">Showing <b>{pagination.current_page}</b> to <b>{pagination.per_page}</b> of <b>{pagination.total}</b> results</div>
                                            <div className="gridjs-pages text-end">
                                                {/* Previous Button */}
                                                <button tabIndex="0" role="button" title="Previous" aria-label="Previous" className={pagination.current_page === 1 ? "disabled" : ""} onClick={() => handlePageChange(pagination.current_page - 1)} disabled={pagination.current_page === 1}> Previous</button>

                                                {/* First Page */}
                                                <button tabIndex="0" role="button" className={` ${pagination.current_page === 1 ? "gridjs-currentPage" : ""}`} title="Page 1" aria-label="Page 1" onClick={() => handlePageChange(1)}> 1</button>

                                                {/* Ellipsis if needed */}
                                                {pagination.current_page > 3 && <span>...</span>}

                                                {/* Middle Pages (2 dynamic pages around current) */}
                                                {Array.from({ length: 5 }, (_, i) => {
                                                    const page = pagination.current_page - 2 + i;
                                                    if (page > 1 && page < pagination.last_page) {
                                                        return (
                                                            <button key={page} tabIndex="0" role="button" className={` ${pagination.current_page === page ? "gridjs-currentPage" : ""}`} title={`Page ${page}`}
                                                                aria-label={`Page ${page}`} onClick={() => handlePageChange(page)}>
                                                                {page}
                                                            </button>
                                                        );
                                                    }
                                                    return null;
                                                })}

                                                {/* Ellipsis if needed */}
                                                {pagination.current_page < pagination.last_page - 2 && <span>...</span>}

                                                {/* Last Page */}
                                                {pagination.last_page > 1 && (
                                                    <button tabIndex="0" role="button" className={` ${pagination.current_page === pagination.last_page ? "gridjs-currentPage" : ""}`} title={`Page ${pagination.last_page}`} aria-label={`Page ${pagination.last_page}`}
                                                        onClick={() => handlePageChange(pagination.last_page)}>
                                                        {pagination.last_page}
                                                    </button>
                                                )}

                                                {/* Next Button */}
                                                <button tabIndex="0" role="button" title="Next" aria-label="Next" className={pagination.current_page === pagination.last_page ? "disabled" : ""} onClick={() => handlePageChange(pagination.current_page + 1)} disabled={pagination.current_page === pagination.last_page}>
                                                    Next
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* /row */}

                    </div>
                </div>

                <div className="modal fade" id="exampleModal" tabindex="-1"
                    aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-xl">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h6 className="modal-title" id="exampleModalLabel1">Withdraw History</h6>
                                <button type="button" className="btn-close" data-bs-dismiss="modal"
                                    aria-label="Close"></button>
                            </div>
                            {isApprove ? (<div className="modal-body">
                                <div className="d-flex p-3 border-top">
                                    <label className="">
                                        <span> <b className="text-primary"> From Address</b></span>
                                    </label>
                                    <span className="ms-auto">{viewData.from_address || 'N/A'}</span>
                                </div>

                                <div className="d-flex p-3 border-top">
                                    <label className="">
                                        <span> <b className="text-primary">To Address</b></span>
                                    </label>
                                    <span className="ms-auto">{viewData.to_address || 'N/A'}</span>
                                </div>

                                <div className="d-flex p-3 border-top">
                                    <label className="">
                                        <span> <b className="text-primary">Available Amount</b></span>
                                    </label>
                                    <span className="ms-auto">{mainBalance || '0'}</span>
                                </div>

                                <div className="d-flex p-3 border-top">
                                    <label className="">
                                        <span> <b className="text-primary">Transfer Amount</b></span>
                                    </label>
                                    <span className="ms-auto">{viewData.paid_amount || '0'}</span>
                                </div>

                                <div className="d-flex p-3 border-top">
                                    <label className="">
                                        <span> <b className="text-primary">Remain Amount</b></span>
                                    </label>
                                    <span className="ms-auto">{mainBalance - viewData.paid_amount || '0'}</span>
                                </div>

                                <div className="row p-3 border-top">
                                 

                                    <div className="d-flex p-3 border-top text-end">
                                        <div className="text-end">
                                            <button className="btn btn-success btn-sm mt-4" onClick={approveWithdraw}>Confirm Withdraw</button>
                                        </div>    

                                    </div>



                                </div>

                            </div>
                            ) : (
                                <div className="modal-body">
                                    <div className="d-flex p-3 border-top">
                                        <label className="">
                                            <span> <b className="text-primary"> User Name</b></span>
                                        </label>
                                        <span className="ms-auto">{viewData.user_name || 'N/A'}</span>
                                    </div>

                                    <div className="d-flex p-3 border-top">
                                        <label className="">
                                            <span> <b className="text-primary">Available Amount</b></span>
                                        </label>
                                        <span className="ms-auto">{viewData.available_amount || 'N/A'}</span>
                                    </div>

                                    <div className="d-flex p-3 border-top">
                                        <label className="">
                                            <span> <b className="text-primary">Withdraw Amount</b></span>
                                        </label>
                                        <span className="ms-auto">{viewData.withdraw_amount || 'N/A'}</span>
                                    </div>

                                    <div className="d-flex p-3 border-top">
                                        <label className="">
                                            <span> <b className="text-primary">Fees Deduction</b></span>
                                        </label>
                                        <span className="ms-auto">{viewData.fees_deduction || 'N/A'}</span>
                                    </div>

                                    <div className="d-flex p-3 border-top">
                                        <label className="">
                                            <span> <b className="text-primary">Paid Amount</b></span>
                                        </label>
                                        <span className="ms-auto">{viewData.paid_amount || 'N/A'}</span>
                                    </div>

                                    <div className="d-flex p-3 border-top">
                                        <label className="">
                                            <span> <b className="text-primary">Remain Amount</b></span>
                                        </label>
                                        <span className="ms-auto">{viewData.remain_amount || 'N/A'}</span>
                                    </div>

                                    <div className="d-flex p-3 border-top">
                                        <label className="">
                                            <span> <b className="text-primary">From Address</b></span>
                                        </label>
                                        <span className="ms-auto">
                                            {viewData.from_address
                                                ? viewData.from_address.slice(0, 10) + '....' + viewData.from_address.slice(-10)
                                                : 'N/A'
                                            }
                                        </span>
                                    </div>

                                    <div className="d-flex p-3 border-top">
                                        <label className="">
                                            <span> <b className="text-primary">To Address</b></span>
                                        </label>
                                        <span className="ms-auto">
                                            {viewData.to_address
                                                ? viewData.to_address.slice(0, 10) + '....' + viewData.to_address.slice(-10)
                                                : 'N/A'
                                            }
                                        </span>
                                    </div>

                                    <div className="d-flex p-3 border-top">
                                        <label className="">
                                            <span> <b className="text-primary">Txn Hash</b></span>
                                        </label>
                                        <span className="ms-auto">
                                            <a className="text-primary" href={'https://bscscan.com/tx/' + viewData.txn_hash}>{viewData.txn_hash
                                                ? viewData.txn_hash.slice(0, 10) + '....' + viewData.txn_hash.slice(-10)
                                                : 'N/A'
                                            }</a>
                                        </span>
                                    </div>

                                    <div className="d-flex p-3 border-top">
                                        <label className="">
                                            <span> <b className="text-primary">Status</b></span>
                                        </label>
                                        <span className="ms-auto">
                                            {viewData && viewData.status
                                                ? viewData.status === 'success' ? (
                                                    <span className="badge bg-success">success</span>
                                                ) : (
                                                    <span className="badge bg-danger">{viewData.status} </span>
                                                ) : 'N/A'
                                            }
                                        </span>
                                    </div>

                                    <div className="d-flex p-3 border-top">
                                        <label className="">
                                            <span> <b className="text-primary">Date Time</b></span>
                                        </label>
                                        <span className="ms-auto">
                                            {viewData.date_time || 'N/A'}
                                        </span>
                                    </div>


                                    <div className="d-flex p-3 border-top">
                                        <label className="">
                                            <span> <b className="text-primary">Remark</b></span>
                                        </label>
                                        <span className="ms-auto">
                                            {viewData.remark || 'N/A'}
                                        </span>
                                    </div>

                                    <hr />

                                    {isRejectPanel ? (
                                        <div className="mt-3">
                                            <div className="row">
                                                <label>Enter Reamrk</label>
                                                <div className="col-md-8 col-sm-12 mt-3">
                                                    <input type="text" className="form-control" value={remark} onChange={(e) => setRemark(e.target.value)} />
                                                </div>
                                                <div className="col-md-4 col-sm-12 text-end mt-3">
                                                    <button className="btn btn-primary btn-sm" onClick={rejectWithdraw}>Submit</button>

                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="mt-3">
                                            {viewData.status === 'pending' ? (
                                                <div>
                                                    <button className="btn btn-success btn-sm lm-3" onClick={() => loadBalance()}>Approve</button>&nbsp;&nbsp;
                                                    <button className="btn btn-danger btn-sm lm-3" onClick={() => setRejectPanel(true)}>Reject</button>
                                                </div>
                                            ) : null}

                                        </div>)}
                                </div>
                            )}

                            <div className="modal-footer">
                                <button type="button" className="btn btn-danger"
                                    data-bs-dismiss="modal">Close</button>
                            </div>
                        </div>
                    </div>
                </div>



                <div class="modal fade" id="modaldemo8">
                    <div class="modal-dialog modal-dialog-centered text-center" role="document">
                        <div class="modal-content modal-content-demo">
                            <div class="modal-header">
                                <h6 class="modal-title">Edit Deposit</h6><button aria-label="Close" class="btn-close" data-bs-dismiss="modal"></button>
                            </div>
                            <div className="modal-body">
                                <div className="d-flex p-3 border-top">
                                    <label>
                                        <span><b className="text-primary">Company</b></span>
                                    </label>
                                    <span className="ms-auto">{viewData.company_name || 'N/A'}</span>
                                </div>

                                <div className="d-flex p-3 border-top">
                                    <label>
                                        <span><b className="text-primary">User ID</b></span>
                                    </label>
                                    <span className="ms-auto">{viewData.client_id || 'N/A'}</span>
                                </div>

                                <div className="d-flex p-3 border-top">
                                    <label>
                                        <span><b className="text-primary">User Name</b></span>
                                    </label>
                                    <span className="ms-auto">{viewData.client_name || 'N/A'}</span>
                                </div>

                                <div className="d-flex p-3 border-top">
                                    <label>
                                        <span><b className="text-primary">Asset</b></span>
                                    </label>
                                    <span className="ms-auto">{viewData.deposit_asset || 'N/A'}</span>
                                </div>

                                <div className="d-flex p-3 border-top">
                                    <label>
                                        <span><b className="text-primary">Network</b></span>
                                    </label>
                                    <span className="ms-auto">{viewData.network_type || 'N/A'}</span>
                                </div>

                                <div className="d-flex p-3 border-top">
                                    <label>
                                        <span><b className="text-primary">Deposit Amount</b></span>
                                    </label>
                                    <span className="ms-auto">{viewData.deposit_amount || 'N/A'}</span>
                                </div>

                                <div className="d-flex p-3 border-top">
                                    <label>
                                        <span><b className="text-primary">Paid Amount</b></span>
                                    </label>
                                    <span className="ms-auto">
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={editPaidAmount}
                                            onChange={(e) => setEditPaidAmount(e.target.value)}
                                        />
                                    </span>
                                </div>

                                <div className="d-flex p-3 border-top">
                                    <label>
                                        <span><b className="text-primary">From Address</b></span>
                                    </label>
                                    <span className="ms-auto">
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={editFromAddress}
                                            onChange={(e) => setEditFromAddress(e.target.value)}
                                        />
                                    </span>
                                </div>

                                <div className="d-flex p-3 border-top">
                                    <label>
                                        <span><b className="text-primary">To Address</b></span>
                                    </label>
                                    <span className="ms-auto">
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={editToAddress}
                                            onChange={(e) => setEditToAddress(e.target.value)}
                                        />
                                    </span>
                                </div>

                                <div className="d-flex p-3 border-top">
                                    <label>
                                        <span><b className="text-primary">Txn Hash</b></span>
                                    </label>
                                    <span className="ms-auto">
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={editTxnHash}
                                            onChange={(e) => setEditTxnHash(e.target.value)}
                                        />
                                    </span>
                                </div>

                                <div className="d-flex p-3 border-top">
                                    <label>
                                        <span><b className="text-primary">Status</b></span>
                                    </label>
                                    <span className="ms-auto">
                                        <select
                                            className="form-control"
                                            value={editStatus}
                                            onChange={(e) => setEditStatus(e.target.value)}
                                        >
                                            <option value="open">Open</option>
                                            <option value="success">Success</option>
                                            <option value="failed">Failed</option>
                                        </select>
                                    </span>
                                </div>

                                <div className="d-flex p-3 border-top">
                                    <label>
                                        <span><b className="text-primary">Date Time</b></span>
                                    </label>
                                    <span className="ms-auto">{viewData.date_time || 'N/A'}</span>
                                </div>
                                <span>{error}</span>
                            </div>
                            <hr />


                            <div className="modal-footer">
                                <button className="btn btn-primary" onClick={updateDeposit}>Save changes</button>
                                <button className="btn btn-light" data-bs-dismiss="modal">Close</button>
                            </div>

                        </div>
                    </div>
                </div>
                <ToastContainer />
            </Header>


            <Footer />

        </>
    )
}

export default Withdraw